import Loadable from 'UIComponents/decorators/Loadable';
import useHasYearInReviewBanner from 'email-management-lib/refactor/yearInReview/hooks/useHasYearInReviewBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncYearInReviewBanner = Loadable({
  loader: () => import( /* webpackChunkName: "year-in-review-banner" */'email-management-lib/refactor/yearInReview/components/YearInReviewBanner'),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
const AsyncYearInReviewBannerWrapper = () => {
  const hasYearInReviewExport = useHasYearInReviewBanner();
  if (hasYearInReviewExport) return /*#__PURE__*/_jsx(AsyncYearInReviewBanner, {});
  return null;
};
export default AsyncYearInReviewBannerWrapper;